export const sportRadarWidgetLanguageList = {
  // https://developer.sportradar.com/docs/read/widgets/General_Information#languages
  en: {
    isoCode: 'en',
    language: 'English',
  },
  en_us: {
    isoCode: 'en_us',
    language: 'English',
  },
  de: {
    isoCode: 'de',
    language: 'Deutsch',
  },
  fr: {
    isoCode: 'fr',
    language: 'Français',
  },
  it: {
    isoCode: 'it',
    language: 'Italiano',
  },
  tr: {
    isoCode: 'tr',
    language: 'Türkçe',
  },
  hr: {
    isoCode: 'hr',
    language: 'Hrvatski',
  },
  sk: {
    isoCode: 'sk',
    language: 'Slovenčina',
  },
  sl: {
    isoCode: 'sl',
    language: 'Slovenščina',
  },
  no: {
    isoCode: 'no',
    language: 'Norsk',
  },
  se: {
    isoCode: 'se',
    language: 'Svenska',
  },
  da: {
    isoCode: 'da',
    language: 'Dansk',
  },
  es: {
    isoCode: 'es',
    language: 'Español',
  },
  nl: {
    isoCode: 'nl',
    language: 'Nederlands',
  },
  pl: {
    isoCode: 'pl',
    language: 'Polski',
  },
  pt: {
    isoCode: 'pt',
    language: 'Português',
  },
  cs: {
    isoCode: 'cs',
    language: 'Česky',
  },
  lv: {
    isoCode: 'lv',
    language: 'Latviešu',
  },
  fi: {
    isoCode: 'fi',
    language: 'Suomeksi',
  },
  ru: {
    isoCode: 'ru',
    language: 'Русский',
  },
  th: {
    isoCode: 'th',
    language: 'ไทย',
  },
  zh: {
    isoCode: 'zh',
    language: '简体中文',
  },
  bs: {
    isoCode: 'bs',
    language: 'Bosanski',
  },
  hu: {
    isoCode: 'hu',
    language: 'Magyar',
  },
  bg: {
    isoCode: 'bg',
    language: 'Български',
  },
  sr: {
    isoCode: 'sr',
    language: 'Cрпски',
  },
  el: {
    isoCode: 'el',
    language: 'Eλληνικά',
  },
  ro: {
    isoCode: 'ro',
    language: 'Română',
  },
  et: {
    isoCode: 'et',
    language: 'Eesti',
  },
  mk: {
    isoCode: 'mk',
    language: 'Македонски',
  },
  lt: {
    isoCode: 'lt',
    language: 'Lietuvių',
  },
  vi: {
    isoCode: 'vi',
    language: 'Tiếng Việt',
  },
  zht: {
    isoCode: 'zht',
    language: '中文繁體',
  },
  id: {
    isoCode: 'id',
    language: 'Bahasa',
  },
  ja: {
    isoCode: 'ja',
    language: '日本語',
  },
  ko: {
    isoCode: 'ko',
    language: '한국어',
  },
  aa: {
    isoCode: 'aa',
    language: 'العربية',
  },
  aze: {
    isoCode: 'aze',
    language: 'Azərbaycan dili',
  },
  ka: {
    isoCode: 'ka',
    language: 'ქართული',
  },
  heb: {
    isoCode: 'heb',
    language: 'עברית',
  },
  sqi: {
    isoCode: 'sqi',
    language: 'Shqip',
  },
  ukr: {
    isoCode: 'ukr',
    language: 'Українська',
  },
  srl: {
    isoCode: 'srl',
    language: 'Srpski',
  },
  me: {
    isoCode: 'me',
    language: 'Crnogorski',
  },
  br: {
    isoCode: 'br',
    language: 'Português do Brasil',
  },
  hye: {
    isoCode: 'hye',
    language: 'Հայերեն',
  },
  sw: {
    isoCode: 'sw',
    language: 'Kiswahili',
  },
  km: {
    isoCode: 'km',
    language: 'ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ',
  },
  tuk: {
    isoCode: 'tuk',
    language: 'Turkmenistan',
  },
  es_la: {
    isoCode: 'es_la',
    language: 'Latin American Spanish',
  },
} as const;
